/**
 * Convert server pendingHarralSpawnbladeWeaponGrantFlyAnimations to viewer-relative fly grant payloads.
 */

const HARRAL_SPAWNBLADE_WEAPON_GRANT_FLY_SOURCE = 'harral_spawnblade_28';

function mapBattlefieldSlotToViewer(playerId, zone, slotIndex, viewerUserId) {
  if (playerId == null || zone == null || slotIndex == null) {
    throw new Error('mapBattlefieldSlotToViewer: playerId, zone, and slotIndex are required');
  }
  const prefix = String(playerId) === String(viewerUserId) ? 'your' : 'opponent';
  return {
    zone: `${prefix}_${zone}`,
    index: slotIndex,
  };
}

function buildHarralSpawnbladeWeaponGrantFlySnapshot(anim) {
  if (anim.weaponInstanceId == null) {
    throw new Error('buildHarralSpawnbladeWeaponGrantFlySnapshot: weaponInstanceId is required');
  }
  if (anim.weaponId == null) {
    throw new Error('buildHarralSpawnbladeWeaponGrantFlySnapshot: weaponId is required');
  }
  return {
    id: anim.weaponId,
    name: anim.weaponName || `Weapon ${anim.weaponId}`,
    instanceId: anim.weaponInstanceId,
    type: 'weapon',
    cost: 0,
    isPlayable: false,
    isOOR: false,
  };
}

function consumePendingHarralSpawnbladeWeaponGrantFlyAnimations(gameStateFragment, viewerUserId) {
  if (!gameStateFragment?.pendingHarralSpawnbladeWeaponGrantFlyAnimations?.length) {
    return [];
  }
  if (viewerUserId == null) {
    throw new Error('consumePendingHarralSpawnbladeWeaponGrantFlyAnimations: viewerUserId is required');
  }

  const pending = [...gameStateFragment.pendingHarralSpawnbladeWeaponGrantFlyAnimations];
  delete gameStateFragment.pendingHarralSpawnbladeWeaponGrantFlyAnimations;

  return pending.map((anim) => {
    if (!anim.animationKey) {
      throw new Error('consumePendingHarralSpawnbladeWeaponGrantFlyAnimations: animationKey is required');
    }
    if (
      anim.spawnbladeZone == null
      || anim.spawnbladeSlotIndex == null
      || anim.targetZone == null
      || anim.targetSlotIndex == null
    ) {
      throw new Error(
        `consumePendingHarralSpawnbladeWeaponGrantFlyAnimations: slots required for ${anim.animationKey}`
      );
    }

    const fromSlot = mapBattlefieldSlotToViewer(
      anim.spawnbladePlayerId,
      anim.spawnbladeZone,
      anim.spawnbladeSlotIndex,
      viewerUserId
    );
    const toSlot = mapBattlefieldSlotToViewer(
      anim.targetPlayerId,
      anim.targetZone,
      anim.targetSlotIndex,
      viewerUserId
    );

    return {
      key: anim.animationKey,
      fromZone: fromSlot.zone,
      fromIndex: fromSlot.index,
      toZone: toSlot.zone,
      toIndex: toSlot.index,
      weaponId: anim.weaponId,
      weaponName: anim.weaponName,
      weaponInstanceId: anim.weaponInstanceId,
      sequenceIndex: anim.sequenceIndex ?? 0,
      source: anim.source || HARRAL_SPAWNBLADE_WEAPON_GRANT_FLY_SOURCE,
      weaponSnapshot: buildHarralSpawnbladeWeaponGrantFlySnapshot(anim),
    };
  });
}

module.exports = {
  HARRAL_SPAWNBLADE_WEAPON_GRANT_FLY_SOURCE,
  consumePendingHarralSpawnbladeWeaponGrantFlyAnimations,
};
